import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';

import {ContextProvider} from '../../components/ContextProvider/ContextProvider';
import {Wrapper, Info} from './NewsletterUnsubscribe.style';

const NewsletterUnsubscribe = props => {
  const {restaurant, isSubscribed} = props;
  const isError = props.location && props.location.pathname.indexOf('error') > -1;
  const title = isSubscribed
    ? isError ? 'newsletterSubscribe.error' : 'newsletterSubscribe.thankYou'
    :
    isError ? 'newsletterUnsubscribe.error' : 'newsletterUnsubscribe.thankYou';

  const message = isError ? (
    <FormattedMessage
      id="newsletterSubOrUnsubscribe.errorMessage"
      values={{foodit: <a href="mailto:help@foodit.com">help@foodit.com</a>}}
    />
  ) : (
    <FormattedMessage
      id="newsletterUnsubscribe.kingRegards"
      values={{restaurantName: restaurant.name}}
    />
  );
  return (
    <Wrapper>
      <Info><FormattedMessage id={title} /></Info>
      <Info>
        {message}
      </Info>
    </Wrapper>
  );
};

NewsletterUnsubscribe.propTypes = {
  restaurant: PropTypes.object.isRequired,
  isSubscribed: PropTypes.bool,
  location: PropTypes.object
};

const mapStateToProps = state => {
  return {
    language: state.language
  };
};

export default connect(mapStateToProps)(ContextProvider(NewsletterUnsubscribe));



// WEBPACK FOOTER //
// ./containers/NewsletterUnsubscribe/NewsletterUnsubscribe.js